export default __webpack_public_path__ + "static/media/facebook.5587d9b0.svg";